import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { ContentService } from "./shared/services/content.service";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { ParallaxModule } from "ngx-parallax";
import { ExternalUrlDirective } from "./external-url.directive";

import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";

import { HomeComponent } from "./pages/home/home.component";
import { WorkListComponent } from "./shared/blocks/work-list/work-list.component";
import { WorkComponent } from "./pages/work/work.component";
import { NavbarComponent } from "./shared/blocks/navbar/navbar.component";
import { HeaderComponent } from "./shared/blocks/header/header.component";
import { SlickCarouselModule } from "ngx-slick-carousel";
import { VittaaAppComponent } from "./pages/vittaa-app/vittaa-app.component";
import { HeaderLogoComponent } from "./shared/blocks/header-logo/header-logo.component";
import { KatWebsiteComponent } from "./pages/kat-website/kat-website.component";
import { VittaaSliderMobileComponent } from "./shared/blocks/vittaa-slider-mobile/vittaa-slider-mobile.component";
import { VittaaBrandingComponent } from "./shared/blocks/vittaa-branding/vittaa-branding.component";
import { VittaaColoursComponent } from "./shared/blocks/vittaa-colours/vittaa-colours.component";
import { VittaaSliderLogoComponent } from "./shared/blocks/vittaa-slider-logo/vittaa-slider-logo.component";
import { VittaaTypoComponent } from "./shared/blocks/vittaa-typo/vittaa-typo.component";
import { VittaaIconsComponent } from "./shared/blocks/vittaa-icons/vittaa-icons.component";
import { KatTypoComponent } from "./shared/blocks/kat-typo/kat-typo.component";
import { KatBrandingComponent } from "./shared/blocks/kat-branding/kat-branding.component";
import { KatColoursComponent } from "./shared/blocks/kat-colours/kat-colours.component";
import { KatSliderLogoComponent } from "./shared/blocks/kat-slider-logo/kat-slider-logo.component";
import { KatSliderDesktopComponent } from "./shared/blocks/kat-slider-desktop/kat-slider-desktop.component";
import { FooterComponent } from "./shared/blocks/footer/footer.component";
import { KatSliderMobileComponent } from "./shared/blocks/kat-slider-mobile/kat-slider-mobile.component";
import { KatSliderBannerComponent } from "./shared/blocks/kat-slider-banner/kat-slider-banner.component";

import { AboutComponent } from "./pages/about/about.component";
import { RandomStuffComponent } from "./shared/blocks/random-stuff/random-stuff.component";
import { AvailabilityComponent } from "./shared/blocks/availability/availability.component";

import { DanviComponent } from "./pages/danvi/danvi.component";
import { Danvi2Component } from "./pages/danvi2/danvi2.component";
import { DanviBrandingComponent } from "./shared/blocks/danvi-branding/danvi-branding.component";
import { DanviBranding2Component } from "./shared/blocks/danvi-branding2/danvi-branding2.component";
import { DanviColoursComponent } from "./shared/blocks/danvi-colours/danvi-colours.component";
import { DanviColours2Component } from "./shared/blocks/danvi-colours2/danvi-colours2.component";
import { DanviSliderDesktopComponent } from "./shared/blocks/danvi-slider-desktop/danvi-slider-desktop.component";
import { DanviSliderLogoComponent } from "./shared/blocks/danvi-slider-logo/danvi-slider-logo.component";
import { DanviSliderMobileComponent } from "./shared/blocks/danvi-slider-mobile/danvi-slider-mobile.component";
import { DanviTypoComponent } from "./shared/blocks/danvi-typo/danvi-typo.component";
import { DanviLabelsComponent } from "./shared/blocks/danvi-labels/danvi-labels.component";
import { LogoAnimationComponent } from "./shared/blocks/logo-animation/logo-animation.component";
import { OndergrondsverbondComponent } from "./pages/ondergrondsverbond/ondergrondsverbond.component";
import { OvSliderPosterComponent } from "./shared/blocks/ov-slider-poster/ov-slider-poster.component";
import { OvSliderLogoComponent } from "./shared/blocks/ov-slider-logo/ov-slider-logo.component";
import { OvBrandingComponent } from "./shared/blocks/ov-branding/ov-branding.component";
import { OvTypoComponent } from "./shared/blocks/ov-typo/ov-typo.component";
import { OvSliderInstaComponent } from "./shared/blocks/ov-slider-insta/ov-slider-insta.component";
import { ScrollTransformComponent } from "./shared/blocks/scroll-transform/scroll-transform.component";
import { AureaComponent } from "./pages/aurea/aurea.component";
import { AureaSliderLogoComponent } from "./shared/blocks/aurea-slider-logo/aurea-slider-logo.component";
import { AureaBrandingComponent } from "./shared/blocks/aurea-branding/aurea-branding.component";
import { AureaTypoComponent } from "./shared/blocks/aurea-typo/aurea-typo.component";
import { AureaColoursComponent } from "./shared/blocks/aurea-colours/aurea-colours.component";
import { DelayStopAnimationDirective } from "./delay-stop-animation.directive";
import { ParallaxDirective } from "./parallax.directive";
import { HeaderLogoHomeComponent } from "./shared/blocks/header-logo-home/header-logo-home.component";
import { HorizontalScrollHomeComponent } from "./shared/blocks/horizontal-scroll-home/horizontal-scroll-home.component";
import { OvLogoComponent } from "./shared/blocks/ov-logo/ov-logo.component";
import { QuoteComponent } from "./shared/blocks/quote/quote.component";
import { KatStickerPackComponent } from "./shared/blocks/kat-sticker-pack/kat-sticker-pack.component";
import { AureaMissionComponent } from "./shared/blocks/aurea-mission/aurea-mission.component";
import { WorkListShortComponent } from "./shared/blocks/work-list-short/work-list-short.component";
import { ServicesComponent } from "./pages/services/services.component";
import { ContactComponent } from "./pages/contact/contact.component";
import { FormComponent } from "./shared/blocks/form/form.component";

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    WorkListComponent,
    WorkComponent,
    NavbarComponent,
    HeaderComponent,
    VittaaAppComponent,
    HeaderLogoComponent,
    KatWebsiteComponent,
    VittaaSliderMobileComponent,
    VittaaBrandingComponent,
    VittaaColoursComponent,
    VittaaSliderLogoComponent,
    VittaaTypoComponent,
    VittaaIconsComponent,
    KatTypoComponent,
    KatBrandingComponent,
    KatColoursComponent,
    KatSliderLogoComponent,
    KatSliderDesktopComponent,
    FooterComponent,
    KatSliderMobileComponent,
    KatSliderBannerComponent,
    AboutComponent,
    RandomStuffComponent,
    AvailabilityComponent,
    ExternalUrlDirective,
    DanviComponent,
    Danvi2Component,
    DanviBrandingComponent,
    DanviBranding2Component,
    DanviColoursComponent,
    DanviColours2Component,
    DanviSliderDesktopComponent,
    DanviSliderLogoComponent,
    DanviSliderMobileComponent,
    DanviTypoComponent,
    DanviLabelsComponent,
    LogoAnimationComponent,
    OndergrondsverbondComponent,
    OvSliderPosterComponent,
    OvSliderLogoComponent,
    OvBrandingComponent,
    OvTypoComponent,
    OvSliderInstaComponent,
    ScrollTransformComponent,
    AureaComponent,
    AureaSliderLogoComponent,
    AureaBrandingComponent,
    AureaTypoComponent,
    AureaColoursComponent,
    DelayStopAnimationDirective,
    ParallaxDirective,
    HeaderLogoHomeComponent,
    HorizontalScrollHomeComponent,
    OvLogoComponent,
    QuoteComponent,
    KatStickerPackComponent,
    AureaMissionComponent,
    WorkListShortComponent,
    ServicesComponent,
    ContactComponent,
    FormComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    SlickCarouselModule,
    ParallaxModule,
  ],

  providers: [ContentService],
  bootstrap: [AppComponent],
})
export class AppModule {}
